/* Brand the existing age-gate image on this theme without changing app configuration or verification behavior. */
(() => {
  if (window.clcBrandLogoOct13) return;
  window.clcBrandLogoOct13 = true;
  const original = 'https://age.blockifyapp.com/s/api/uploads/9e31af7e-003e-4863-97c3-af119b7685ac-morgasmofficialnewcolorlogo.png';
  const replacement = 'https://cdn.shopify.com/s/files/1/0548/8853/0020/files/clc-morgasm-logo-oct13.png';
  function update() { document.querySelectorAll('img').forEach(img => { if (img.getAttribute('src') === original) img.src = replacement; }); }
  function start() { update(); new MutationObserver(update).observe(document.body, {childList:true,subtree:true,attributes:true,attributeFilter:['src']}); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true}); else start();
})();
